import store from '../store'

export default {
  load: {
    key: 'AIzaSyACtDfWX6-_dN1d2dCnHe5G0OxfbblAil8',
    libraries: 'visualization',
    language: store.state.lang,
    region: store.state.lang
  }
}



// WEBPACK FOOTER //
// ./src/mixins/googlemapsOptions.js